<template lang="pug">
b-modal#editVip(
  ref="editVip"
  :title="$t('ui.combine.edit_vip')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.vip_id')" disabled).mb-0.d-none
      DebounceInput(
        size="sm"
        ref="vip_id"
        required
        type="text"
        :dirty="$v.vip_id.$dirty"
        :error="$v.vip_id.$error"
        v-model.trim.lazy="$v.vip_id.$model"
      )
      ValidateResult(:value="$v.vip_id" :name="$t('ui.vip_name')")
    b-form-group.mb-0
      label {{ $t('ui.vip_name') }}
      i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_vip_name')")
      DebounceInput(
        size="sm"
        ref="vip_name"
        required
        type="text"
        :dirty="$v.vip_name.$dirty"
        :error="$v.vip_name.$error"
        v-model.trim.lazy="$v.vip_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.vip_name" :name="$t('ui.vip_name')")
    b-form-group(:label="$t('ui.deposit')" :class="{ 'd-none' : vip_id === 1 }").mb-0
      DebounceInput(
        size="sm"
        ref="deposit"
        type="text"
        :dirty="$v.deposit.$dirty"
        :error="$v.deposit.$error"
        v-model.trim.lazy="$v.deposit.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.deposit" :name="$t('ui.deposit')")
    b-form-group(:label="$t('ui.turnover')" :class="{ 'd-none' : vip_id === 1 }").mb-0
      DebounceInput(
        ref="turnover"
        size="sm"
        required
        type="text"
        :dirty="$v.turnover.$dirty"
        :error="$v.turnover.$error"
        v-model.trim.lazy="$v.turnover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.turnover" :name="$t('ui.turnover')")
    b-form-group(:label="$t('ui.maintain_deposit')" :class="{ 'd-none' : vip_id === 1 }").mb-0
      DebounceInput(
        size="sm"
        ref="maintain_deposit"
        type="text"
        :dirty="$v.maintain_deposit.$dirty"
        :error="$v.maintain_deposit.$error"
        v-model.trim.lazy="$v.maintain_deposit.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.maintain_deposit" :name="$t('ui.maintain_deposit')")
    b-form-group(:label="$t('ui.maintain_turnover')" :class="{ 'd-none' : vip_id === 1 }").mb-0
      DebounceInput(
        ref="maintain_turnover"
        size="sm"
        required
        type="text"
        :dirty="$v.maintain_turnover.$dirty"
        :error="$v.maintain_turnover.$error"
        v-model.trim.lazy="$v.maintain_turnover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.maintain_turnover" :name="$t('ui.maintain_turnover')")
    b-form-group(:label="$t('ui.reward_type')" :class="{ 'd-none' : vip_id === 1 }").mb-0
      VipRewardType(
        ref="reward_type"
        size="sm"
        required
        type="array"
        :dirty="$v.reward_type.$dirty"
        :error="$v.reward_type.$error"
        v-model.trim.lazy="$v.reward_type.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.reward_type" :name="$t('ui.reward_type')")
    template(v-if="reward_type == 'CASH'")
      b-form-group(:label="$t('ui.cash')" :class="{ 'd-none' : vip_id === 1 }").mb-0
        DebounceInput(
          size="sm"
          ref="cash"
          required
          type="text"
          :dirty="$v.cash.$dirty"
          :error="$v.cash.$error"
          v-model.trim.lazy="$v.cash.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.cash" :name="$t('ui.cash')")
      b-form-group(:label="$t('ui.campaign_id')" :class="{ 'd-none' : vip_id === 1 }").mb-0
        CampaignLookup(
          :operatorID="operatorID"
          size="sm"
          ref="campaign_id"
          required
          type="array"
          :dirty="$v.campaign_id.$dirty"
          :error="$v.campaign_id.$error"
          v-model.trim.lazy="$v.campaign_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
    template(v-if="reward_type == 'CS'")
      b-form-group(:label="$t('ui.cs')" :class="{ 'd-none' : vip_id === 1 }").mb-0
        DebounceInput(
          size="sm"
          ref="cs"
          required
          type="text"
          :dirty="$v.cs.$dirty"
          :error="$v.cs.$error"
          v-model.trim.lazy="$v.cs.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.cs" :name="$t('ui.cs')")
      b-form-group(:label="$t('ui.social_platform')" :class="{ 'd-none' : vip_id === 1 }").mb-0
        SocialPlatformLookup(
          size="sm"
          ref="social_platform"
          required
          type="array"
          :dirty="$v.social_platform.$dirty"
          :error="$v.social_platform.$error"
          v-model.trim.lazy="$v.social_platform.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.social_platform" :name="$t('ui.social_platform')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipRewardType from "@/library/VipRewardType";
import SocialPlatformLookup from "@/library/SocialPlatformLookup";
import CampaignLookup from "@/library/CampaignLookup";
const alphaNumWithUnicode = helpers.regex("alphaNumWithUnicode", /^([^\u0000-\u007F]|[A-Za-z0-9\s])+$/i);
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipRewardType,
    SocialPlatformLookup,
    CampaignLookup
  },
  props: {
    operatorID: {
      type: String,
      default: ""
    },
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: "",
      vip_id: "",
      vip_name: "",
      deposit: 0,
      turnover: 0,
      maintain_deposit: 0,
      maintain_turnover: 0,
      reward_type: "",
      cash: 0,
      campaign_id: "",
      cs: "",
      social_platform: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {  },
  validations: {
    vip_id: {
      required
    },
    vip_name: {
      required,
      alphaNumWithUnicode,
      minLength: minLength(1),
      maxLength: maxLength(20)
    },
    deposit: {
      decimal,
      required
    },
    turnover: {
      decimal,
      required
    },
    maintain_deposit: {
      decimal,
      minValue(value) {
        if (this.maintain_turnover == 0) {
          return minValue(1)(value)
        } else {
          return minValue(0)(value)
        }
      },
      required: requiredIf(function () {
        return this.maintain_turnover == 0;
      })
    },
    maintain_turnover: {
      decimal,
      minValue(value) {
        if (this.maintain_deposit == 0) {
          return minValue(1)(value)
        } else {
          return minValue(0)(value)
        }
      },
      required: requiredIf(function () {
        return this.maintain_deposit == 0;
      })
    },
    reward_type: {
      required
    },
    cash: {
      required: requiredIf(function () {
        return this.reward_type == 'CASH';
      })
    },
    campaign_id: {
      required: requiredIf(function () {
        return this.reward_type == 'CASH';
      })
    },
    cs: {
      required: requiredIf(function () {
        return this.reward_type == 'CS';
      })
    },
    social_platform: {
      required: requiredIf(function () {
        return this.reward_type == 'CS';
      })
    }
  },
  watch : {
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.vipEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          vip_id: this.vip_id,
          vip_name: this.vip_name,
          deposit: this.deposit,
          turnover: this.turnover,
          maintain_deposit: this.maintain_deposit,
          maintain_turnover: this.maintain_turnover,
          reward_type: this.reward_type,
          cash: this.cash,
          campaign_id: this.campaign_id,
          cs: this.cs,
          social_platform: this.social_platform,
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editVip.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_vip", this.feedback.status);
                  this.$refs.editVip.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.vip_id = this.item.vip_id;
      this.vip_name = this.item.vip_name;
      this.deposit = this.item.deposit;
      this.turnover = this.item.turnover;
      this.maintain_deposit = this.vip_id === 1 ? 1 : this.item.maintain_deposit;
      this.maintain_turnover = this.vip_id === 1 ? 1 : this.item.maintain_turnover;
      this.reward_type = ['',null].includes(this.item.reward_type) ? "NOREWARD" : this.item.reward_type;
      this.cash = this.item.cash;
      this.campaign_id = this.item.campaign_id ? this.item.campaign_id : "";
      this.cs = this.item.cs;
      this.social_platform = this.item.social_platform;
      this.$refs.vip_name.$el.focus();
    }
  }
};
</script>
